import React, {useRef, useState, useEffect } from 'react';
import $ from "jquery";
import * as Fathom from 'fathom-client';
import { fetchLatestReleaseUrl, openInNewTab } from './util';

import Menu from "./components/elements/menu";
import Popup from "./components/elements/popup";
import Header from "./components/elements/header";
import Footer from "./components/elements/footer";

import Intro from "./components/sections/intro";
import Features from "./components/sections/features";
import Structure from "./components/sections/structure";
import Spaces from "./components/sections/spaces";
import Platforms from "./components/sections/platforms";
import Community from "./components/sections/community";

import '../scss/common.scss';

const App = () => {

    const nodeRef: any = useRef(null);
    const menuRef: any = useRef(null);
    const popupRef: any = useRef(null);
    const marksRef: any = useRef({ 'Mark1': {}, 'Mark2': {} });
    const defaultUrl = 'https://download.anytype.io/';
    const [ releases, setReleases ] = useState<any[]>([]);
    const win: any = $(window);

    const setMarks = (cb: () => void) => {
	Object.keys(marksRef.current).forEach((mark: string, idx: number) => {
	    const el = $(nodeRef?.current).find(`#${mark}`);
	    const top = el.offset()?.top || 0;

	    if (!top) {
		return;
	    };

	    marksRef.current[mark].position = top - win.innerHeight() / 2;
	    marksRef.current[mark].name = mark;
	    marksRef.current[mark].reached = false;
	});

	cb();
    };

    const onScroll = () => {
	const top = win.scrollTop();

	for (const k in marksRef.current) {
	    const { name, position, reached } = marksRef.current[k];

	    if (!reached && (top >= position)) {
		Fathom.trackEvent(`SitePageScroll${name}`);
		marksRef.current[k].reached = true;
	    };
	};
    };

    const onMenuOpen = () => {
	menuRef?.current?.show();
    };

    const onDownload = (data?: any) => {
	Fathom.trackEvent('Download click');

	if (!data) {
	    openInNewTab(defaultUrl);
	    return;
	};

	const { url, event } = data;

	openInNewTab(url);
	if (event) {
	    Fathom.trackEvent(event);
	};
    };

    const onSubscribe = () => {
	menuRef?.current?.hide();
	popupRef?.current?.show();
    };

    useEffect(() => {
	Fathom.load('LEHWLRWV');

	setMarks(() => {
	    win.off('scroll').on('scroll', onScroll);
	});

	fetchLatestReleaseUrl().then((items) => {
	    if (!items.length) {
		console.log('Platform not supported or release unavailable.');
	    };
	    setReleases(items);
	});
    }, []);

    return (
	<div ref={nodeRef} className="app">
	    <div className="logo fix" />
	    <Header onMenuOpen={onMenuOpen} />
	    <Menu onSubscribe={onSubscribe} ref={menuRef} />
	    <Popup ref={popupRef} />

	    <div className="sections">
		<Intro onDownload={onDownload} releases={releases} />
		<Features />
		<Structure />
		<Spaces />
		<Platforms />
		<Community onDownload={onDownload} releases={releases} />
	    </div>

	    <Footer onSubscribe={onSubscribe} />
	</div>
    );

};

export default App;